export function mapRecordingEnumType(type: string) {
    switch (type) {
        case 'WEBINAR':
        case 'WEBINARS':
        case 'webinar':
        case 'webinars':
            return 'webinar';
        case 'WORKSHOP':
        case 'WORKSHOPS':
        case 'workshop':
        case 'workshops':
            return 'workshop';
        case 'COMPETITION':
        case 'COMPETITIONS':
        case 'competition':
        case 'competitions':
            return 'competition';
        default:
            return 'webinar';
    }
}